import { OneTrustService } from '@altack/ngx-onetrust';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';

@Component({
  selector: 'app-kb-cookies-consent-page',
  templateUrl: './kb-cookies-consent-page.component.html',
  styleUrls: ['./kb-cookies-consent-page.component.scss'],
  standalone: false
})
export class KbCookiesConsentPageComponent {
  public oneTrustService = inject(OneTrustService);
  langservice = inject(KBLanguageService);
  cdr = inject(ChangeDetectorRef);

  apiRes: any;
  avoidPageLoadCall: boolean = false;
  platformId = inject(PLATFORM_ID);
  private unsubscribe$ = new Subject<void>();
  ngOnInit() {
    this.getHTML();
    this.hideElements();
  }

  ngAfterViewInit() {
    this.langservice.getActive().pipe(takeUntil(this.unsubscribe$)).subscribe((lang: string) => {
      if (this.avoidPageLoadCall) {
        this.getHTML();
      }
    });
  }

  getHTML() {
    const onetrust = this.oneTrustService.oneTrustInstance$();
    onetrust.pipe(takeUntil(this.unsubscribe$)).pipe(takeUntil(this.unsubscribe$)).subscribe((x) => {

      const html = x.GetDomainData();
      this.apiRes = html['MainInfoText'];
      this.avoidPageLoadCall = true;
      this.cdr.detectChanges();
    });
  }

  hideElements() {
    if (isPlatformBrowser(this.platformId)) {
      const fadeInElement = document.querySelector('.ot-fade-in');
      const hashElement = document.querySelector('#onetrust-pc-sdk');

      if (fadeInElement) {
        (fadeInElement as HTMLElement).style.display = 'none';
      }

      if (hashElement) {
        (hashElement as HTMLElement).style.display = 'none';
      }
    }
  }


  ngOnDestroy() {
    this.oneTrustService.oneTrustInstance$().pipe(takeUntil(this.unsubscribe$)).subscribe((x) => {
      if (!x.IsAlertBoxClosed()) {
        x.ToggleInfoDisplay();
      }
    });
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

  }

}
